module.exports = "<!-- Ghost -->\n<div class=\"box-ghost\" [ngClass]=\"containerClass\" *ngIf=\"!hidden\" (click)=\"clickedFn()\">\n  <!-- box -->\n  <div class=\"box\" [ngClass]=\"boxClass\">\n    <i class=\"fa fa-plus mr-1\" [ngClass]=\"iconClass\" aria-hidden=\"true\"></i>\n    <span>{{ text }}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/flow/ghost-box/ghost-box.component.html
// module id = ./src/app/flow/ghost-box/ghost-box.component.html
// module chunks = main